
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Works() {
  const works = [
    {
      title: '製造業A社様 定期配送業務',
      category: '一般貨物運送',
      client: '製造業',
      period: '2025年9月〜継続中',
      description: '京都から大阪への定期配送業務を担当。4tトラックによる週3回の定期便で、製品の安全な輸送を実現。',
      results: [
        '配送時間30%短縮',
        'コスト25%削減',
        '事故・破損ゼロ'
      ],
      image: 'Manufacturing company products being loaded onto professional delivery truck, industrial logistics operation, blue and white commercial vehicle, professional photography'
    },
    {
      title: 'EC事業者B社様 当日配送サービス',
      category: '軽貨物運送',
      client: 'EC事業者',
      period: '2025年9月〜継続中',
      description: '関西圏での当日配送サービスを提供。軽貨物車両による迅速な配送で顧客満足度向上に貢献。',
      results: [
        '当日配送率99%達成',
        '顧客満足度95%',
        '配送エリア拡大'
      ],
      image: 'E-commerce packages being delivered by light commercial vehicle in urban setting, fast delivery service, modern logistics solution, professional business photography'
    },
    {
      title: '小売業C社様 店舗間配送',
      category: '一般貨物運送',
      client: '小売業',
      period: '2025年9月〜継続中',
      description: '関西圏の複数店舗間での商品配送を担当。効率的なルート設計により配送コストを大幅削減。',
      results: [
        '配送ルート最適化',
        'コスト40%削減',
        '配送精度99.5%'
      ],
      image: 'Retail store merchandise being transported between locations, organized commercial delivery, professional logistics service, clean business photography'
    },
    {
      title: '物流業者D社様 協力配送',
      category: '協力配送',
      client: '物流業者',
      period: '2025年9月〜継続中',
      description: '繁忙期の配送業務をサポート。柔軟な対応力で急な配送依頼にも迅速に対応。',
      results: [
        '繁忙期対応100%',
        '緊急配送対応',
        '長期パートナーシップ'
      ],
      image: 'Logistics partnership operation with multiple delivery vehicles, collaborative transportation service, professional fleet management, business cooperation concept'
    },
    {
      title: '食品メーカーE社様 冷蔵配送',
      category: '特殊配送',
      client: '食品メーカー',
      period: '2025年9月〜継続中',
      description: '冷蔵・冷凍食品の温度管理配送を担当。品質保持と安全性を最優先とした配送サービス。',
      results: [
        '温度管理100%',
        '品質保持率99.8%',
        '配送時間短縮'
      ],
      image: 'Refrigerated food products being transported in temperature-controlled vehicle, cold chain logistics, food safety transportation, professional delivery service'
    },
    {
      title: '建設業F社様 資材配送',
      category: '一般貨物運送',
      client: '建設業',
      period: '2025年9月〜継続中',
      description: '建設現場への資材配送を担当。重量物の安全な輸送と現場スケジュールに合わせた柔軟な配送。',
      results: [
        '現場納期100%達成',
        '安全配送記録',
        '作業効率向上'
      ],
      image: 'Construction materials being delivered to building site, heavy cargo transportation, industrial delivery truck, professional construction logistics'
    }
  ];

  const stats = [
    {
      number: '50+',
      label: '取引実績',
      description: '様々な業界のお客様'
    },
    {
      number: '99.8%',
      label: '配送精度',
      description: '確実な配送サービス'
    },
    {
      number: '24時間',
      label: '対応体制',
      description: '緊急時も安心'
    },
    {
      number: '100%',
      label: '顧客満足度',
      description: '継続取引率'
    }
  ];

  const testimonials = [
    {
      company: '製造業A社',
      representative: '物流部長',
      comment: 'SUNFIELDさんのおかげで配送効率が大幅に改善されました。若いスタッフの皆さんの熱意と対応力に感謝しています。',
      rating: 5
    },
    {
      company: 'EC事業者B社',
      representative: '代表取締役',
      comment: '当日配送サービスの品質が素晴らしく、お客様からの評価も上がりました。今後も長くお付き合いしたいパートナーです。',
      rating: 5
    },
    {
      company: '小売業C社',
      representative: '店舗運営部',
      comment: '柔軟な対応と確実な配送で、店舗運営がスムーズになりました。コスト削減効果も期待以上でした。',
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/7bb4250df051c634a6a8ebcf7294cd66.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">実績紹介</h1>
          <p className="text-xl text-blue-200">Works</p>
        </div>
      </section>

      {/* 実績統計 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              SUNFIELDの実績
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              設立以来、多くのお客様にご信頼いただき、確実な成果を上げています。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-xl p-8 mb-4">
                  <div className="text-4xl md:text-5xl font-bold text-yellow-400 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-white font-semibold text-lg">
                    {stat.label}
                  </div>
                </div>
                <p className="text-gray-600">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 主要実績 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              主要取引実績
            </h2>
            <p className="text-xl text-gray-600">
              様々な業界のお客様との取引実績をご紹介します
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {works.map((work, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img
                  src={`https://readdy.ai/api/search-image?query=$%7Bwork.image%7D&width=600&height=300&seq=work-${index}&orientation=landscape`}
                  alt={work.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-sm font-semibold">
                      {work.category}
                    </span>
                    <span className="text-gray-500 text-sm">{work.period}</span>
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-2">{work.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{work.description}</p>
                  <div className="space-y-2">
                    <h4 className="font-semibold text-blue-900">主な成果:</h4>
                    <ul className="space-y-1">
                      {work.results.map((result, resultIndex) => (
                        <li key={resultIndex} className="flex items-center text-sm text-gray-700">
                          <i className="ri-check-line text-green-500 mr-2"></i>
                          {result}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* お客様の声 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              お客様の声
            </h2>
            <p className="text-xl text-gray-600">
              実際にサービスをご利用いただいたお客様からの評価
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, starIndex) => (
                    <i key={starIndex} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed italic">
                  "{testimonial.comment}"
                </p>
                <div className="border-t border-gray-300 pt-4">
                  <p className="font-semibold text-blue-900">{testimonial.company}</p>
                  <p className="text-gray-600 text-sm">{testimonial.representative}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 業界別実績 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              業界別実績
            </h2>
            <p className="text-xl text-gray-600">
              幅広い業界でのサービス提供実績
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {[
              { name: '製造業', count: '15社', icon: 'ri-settings-line' },
              { name: 'EC事業', count: '12社', icon: 'ri-shopping-cart-line' },
              { name: '小売業', count: '10社', icon: 'ri-store-line' },
              { name: '物流業', count: '8社', icon: 'ri-truck-line' },
              { name: '食品業', count: '6社', icon: 'ri-restaurant-line' },
              { name: '建設業', count: '5社', icon: 'ri-building-line' }
            ].map((industry, index) => (
              <div key={index} className="bg-white rounded-xl p-6 text-center shadow-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className={`${industry.icon} text-blue-900 text-xl`}></i>
                </div>
                <h3 className="font-bold text-blue-900 mb-1">{industry.name}</h3>
                <p className="text-gray-600 text-sm">{industry.count}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 配送エリア実績 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              配送エリア実績
            </h2>
            <p className="text-xl text-gray-600">
              関西圏全域での豊富な配送実績
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { area: '京都府', routes: '120+', description: '京都市内・宇治・八幡など' },
              { area: '大阪府', routes: '200+', description: '大阪市・堺市・東大阪など' },
              { area: '奈良県', routes: '80+', description: '奈良市・橿原・生駒など' },
              { area: '兵庫県', routes: '150+', description: '神戸市・尼崎・西宮など' }
            ].map((area, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
                <h3 className="text-xl font-bold text-blue-900 mb-2">{area.area}</h3>
                <div className="text-2xl font-bold text-blue-700 mb-2">{area.routes}</div>
                <p className="text-gray-700 text-sm">配送ルート</p>
                <p className="text-gray-600 text-xs mt-2">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            あなたの会社も実績の一つに
          </h2>
          <p className="text-xl text-blue-200 mb-8">
            豊富な実績と経験を活かし、お客様のビジネス成功をサポートいたします。まずはお気軽にご相談ください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              お問い合わせ
            </Link>
            <Link
              to="/voice"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-blue-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-quote-line mr-2"></i>
              お客様の声
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
